// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3a2lO","head":"Table_head__fyj06","col":"Table_col__7TTUk"};